<template></template>
<script>
import { mapGetters } from 'vuex'

export default {
  name: 'live-packages',

  computed: {
    ...mapGetters({
      activeProperties: 'property/activeProperties',
      lotPriceRanges: 'filter/priceRanges',
      lotSizeRanges: 'filter/lotSizeRanges',
      dwellingSizeRanges: 'filter/dwellingSizeRanges'
    })
  },

  watch: {
    $route: {
      handler (to, from) {
        this.setFilterParameters()
      },
      immediate: true
    }
  },

  methods: {
    setFilterParameters () {
      const lot = this.$route.query.lot ? this.$route.query.lot : ''

      this.$store.commit('filter/SET_FILTER_PARAMETERS', {
        inputPriceRange: this.lotPriceRanges,
        inputLotSizeRange: this.lotSizeRanges,
        inputDwellingSizeRange: this.dwellingSizeRanges,
        inputBeds: false,
        inputBaths: false,
        inputCars: false,
        inputLotNumber: lot,
        inputBuilder: ''
      })
    }
  }
}
</script>
